import React from 'react'
import {Icon} from '@chakra-ui/react'

const CheckIconBlackNoCIrcle = (props) => {
    return (
        <Icon viewBox="0 0 16 12" fill="none" {...props}>
            <path
                d="M14.0247 1.41797L5.35757 10.0851L1.41797 6.14549"
                stroke="#13183A"
                strokeWidth="2.83651"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default CheckIconBlackNoCIrcle
